(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gift-showcase')) {
    customElements.define('gift-showcase', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const track = this.querySelector('.gm-gifts__track');
        const controls = this.querySelector('.gm-gifts__controls');
        const previous = controls.querySelector('[data-gift-step="-1"]');
        const next = controls.querySelector('[data-gift-step="1"]');
        const dots = this.querySelector('.gm-gifts__dots');
        const cards = Array.from(track.children);
        dots.replaceChildren();
        const dotButtons = cards.map((card, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', `${index + 1}: ${card.querySelector('h3')?.textContent.trim() || ''}`);
          button.setAttribute('aria-controls', track.id);
          button.addEventListener('click', () => {
            const left = card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
            track.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          }, { signal: this.abort.signal });
          dots.append(button);
          return button;
        });
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          controls.hidden = max < 4;
          dots.hidden = max < 4;
          let current = 0;
          let distance = Infinity;
          cards.forEach((card, index) => {
            const left = Math.min(max, card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft);
            const delta = Math.abs(left - track.scrollLeft);
            if (delta <= distance) { distance = delta; current = index; }
          });
          dotButtons.forEach((button, index) => button.setAttribute('aria-current', String(index === current)));
          previous.disabled = track.scrollLeft < 3;
          next.disabled = track.scrollLeft >= max - 3;
        };
        controls.addEventListener('click', event => {
          const button = event.target.closest('[data-gift-step]');
          if (!button) return;
          const card = track.firstElementChild;
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
          track.scrollBy({ left: step * Number(button.dataset.giftStep), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal: this.abort.signal });
        track.addEventListener('scroll', update, { passive: true, signal: this.abort.signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() { this.abort?.abort(); this.abort = null; this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
	if (!customElements.get('article-inline-products')) {
		customElements.define('article-inline-products', class extends HTMLElement {
			connectedCallback() {
				if (this.initialized) return;
				this.initialized = true;
				const article = this.closest('.blog-post-detail');
				const content = article ? article.querySelector('[data-article-content]') : null;
				const templates = Array.from(this.querySelectorAll('[data-article-product-template]'));
				if (!content || templates.length === 0) return;
				let instanceIndex = 0;

				const createBlock = (selectedTemplates) => {
					const block = document.createElement('section');
					block.className = 'article-inline-products-block';
					const heading = this.dataset.heading ? document.createElement('p') : null;
					if (heading) {
						heading.className = 'article-inline-products-block__heading';
						heading.textContent = this.dataset.heading;
						block.append(heading);
					}
					const list = document.createElement('div');
					list.className = 'article-inline-products-block__list';
					selectedTemplates.forEach((template) => {
						const fragment = template.content.cloneNode(true);
						const productForm = fragment.querySelector('product-form');
						const form = fragment.querySelector('form');
						if (productForm && form) {
							instanceIndex += 1;
							const sectionId = `${productForm.dataset.section}-${instanceIndex}`;
							productForm.dataset.section = sectionId;
							form.id = `product-form-${sectionId}`;
						}
						list.append(fragment);
					});
					block.append(list);
					return block;
				};

				const normalizeShortcode = (value) => value
					.replace(/[\u200B-\u200D\u2060\uFEFF]/g, '')
					.replace(/\u00A0/g, ' ')
					.trim();
				const allCardsPattern = /^\[product-cards\]$/i;
				const singleCardPattern = /^\[product-card:(\d+)\]$/i;
				const markerSelector = 'p, li, div, blockquote';
				const markers = Array.from(content.querySelectorAll(markerSelector)).filter((marker) => {
					const value = normalizeShortcode(marker.textContent);
					if (!allCardsPattern.test(value) && !singleCardPattern.test(value)) return false;

					return !Array.from(marker.querySelectorAll(markerSelector)).some((descendant) => {
						const descendantValue = normalizeShortcode(descendant.textContent);
						return allCardsPattern.test(descendantValue) || singleCardPattern.test(descendantValue);
					});
				});

				markers.forEach((marker) => {
					const value = normalizeShortcode(marker.textContent);
					if (allCardsPattern.test(value)) {
						marker.replaceWith(createBlock(templates));
						return;
					}
					const match = value.match(singleCardPattern);
					if (!match) return;
					const selectedTemplate = templates.find((template) => template.dataset.articleProductTemplate === match[1]);
					if (selectedTemplate) marker.replaceWith(createBlock([selectedTemplate]));
				});
			}
		});
	}
	if (!customElements.get('article-overview')) {
		customElements.define('article-overview', class extends HTMLElement {
			connectedCallback() {
				const content = this.parentElement.querySelector('[data-article-content]');
				const list = this.querySelector('[data-article-overview-list]');
				const toggle = this.querySelector('.article-overview__toggle');
				const panel = this.querySelector('.article-overview__panel');
				const count = this.querySelector('[data-article-overview-count]');
				const panelCount = this.querySelector('[data-article-overview-panel-count]');
				if (!content || !list || !toggle || !panel) return;

				const headings = Array.from(content.querySelectorAll('h2')).filter((heading) => {
					const title = heading.textContent.trim();
					return title && !/^(products mentioned|recommended products|leave a comment)$/i.test(title) &&
						!heading.closest('.article-inline-products-block, .comment-respond, .article-more');
				});
				if (headings.length < 2) return;
				if (count) count.textContent = headings.length;
				if (panelCount) panelCount.textContent = headings.length;

				list.replaceChildren();
				headings.forEach((heading, index) => {
					if (!heading.id) heading.id = `article-section-${index + 1}`;
					const item = document.createElement('li');
					const link = document.createElement('a');
					link.href = `#${heading.id}`;
					link.textContent = heading.textContent.trim();
					item.append(link);
					list.append(item);
				});

				let pinned = false;
				let closeTimer;
				const showPanel = () => {
					window.clearTimeout(closeTimer);
					panel.hidden = false;
					toggle.setAttribute('aria-expanded', 'true');
				};
				const hidePanel = () => {
					window.clearTimeout(closeTimer);
					panel.hidden = true;
					toggle.setAttribute('aria-expanded', 'false');
				};

				this.addEventListener('pointerenter', () => {
					if (window.matchMedia('(hover: hover)').matches) showPanel();
				});
				this.addEventListener('pointerleave', () => {
					window.clearTimeout(closeTimer);
					if (!pinned) {
						closeTimer = window.setTimeout(() => {
							if (!pinned && !this.matches(':hover') && !this.contains(document.activeElement)) hidePanel();
						}, 200);
					}
				});
				toggle.addEventListener('click', () => {
					pinned = !pinned;
					if (pinned) showPanel();
					else hidePanel();
				});
				this.addEventListener('focusin', showPanel);
				this.addEventListener('focusout', () => {
					window.setTimeout(() => {
						if (!pinned && !this.contains(document.activeElement)) hidePanel();
					});
				});
				this.addEventListener('keydown', (event) => {
					if (event.key !== 'Escape') return;
					pinned = false;
					hidePanel();
					toggle.focus();
				});
				list.addEventListener('click', () => {
					pinned = false;
					hidePanel();
				});

				this.hidden = false;
			}
		});
	}

  } catch(e) { console.error(e); }
})();
})();
